export function getAmountInDollarFormat(amount, decimalPlaces = 2) {
  return amount.toFixed(decimalPlaces);
}
